import Api from '../abstract';

export let LIST = (params, successCallback, errorCallback) => {
    let url = `/user/export?${params.payload.query}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let CREATE = (params, successCallback, errorCallback) => {
    let url = `/user/export`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let DELETE = (params, successCallback, errorCallback) => {
    let url = `/user/export/${params.payload.id}`;
    return Api.delete(url).then(successCallback).catch(errorCallback);
};
